import { useState } from "react";
import Block from './block1';

const EditableBlockList = ({ onRecommendChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div className="position-relative">
        <p
          className="py-3 fw-bold ms-5"
          onClick={toggleDropdown}
        >
          Non-Pharmacological Recommendations
          <i className="bi bi-caret-down-fill" style={{ color: '#FF9800' }}></i>
        </p>
      </div>

      {isOpen && (
        <div className="row">
          <div className="col-12 mx-auto">
            <Block
              initialLabel="Notes"
              initialContent=".Increase fluid intake to at least 2 liters per day to help flush out the urinary tract."
              onContentChange={onRecommendChange}  // Appel de la fonction de callback lors d'un changement de contenu
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EditableBlockList;
